import React from 'react';
import clsx from 'clsx';
import { CheckCircleIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

interface LinhaSecaoMovimentacaoProps {
  titulo: string;
  /** Uma linha do que já está registrado (ex.: "Correios · envio 21/10 · recebimento a definir"). */
  resumo: string;
  concluida: boolean;
  /** Próximo passo: realça a linha. */
  destaque?: boolean;
  aberta: boolean;
  onAbrir: () => void;
}

/** Linha fechada de uma parte da Movimentação (Logística, Termo) — clicar abre o formulário
 * na gaveta ao lado, sem empurrar o resto da tela. */
export default function LinhaSecaoMovimentacao({
  titulo,
  resumo,
  concluida,
  destaque = false,
  aberta,
  onAbrir,
}: LinhaSecaoMovimentacaoProps) {
  return (
    <button
      type="button"
      aria-pressed={aberta}
      onClick={onAbrir}
      className={clsx(
        'flex w-full items-center justify-between gap-3 rounded-lg px-3 py-3 text-left text-sm',
        aberta
          ? 'border-2 border-primary-500 bg-primary-50'
          : destaque
            ? 'border border-amber-300 bg-amber-50 hover:bg-amber-100'
            : 'border border-gray-200 bg-white hover:bg-gray-50'
      )}
    >
      <span className="flex min-w-0 items-center gap-2">
        {concluida && <CheckCircleIcon className="h-5 w-5 shrink-0 text-green-600" aria-label="Concluída" />}
        <span className="font-semibold text-gray-900">{titulo}</span>
        <span className={clsx('truncate', destaque && !aberta ? 'text-amber-900' : 'text-gray-600')}>· {resumo}</span>
      </span>
      <ChevronRightIcon className="h-4 w-4 shrink-0 text-gray-500" aria-hidden="true" />
    </button>
  );
}
